var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurveyImageDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 372,
    height: 206,
    viewBox: "0 0 372 206",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "9ag2zbigbb",
    d: "M0.351 0.6H125.351V143.6H0.351z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "g2zuulmw4c",
    d: "M20.715 61.308s.399-.929.598-1.657c.2-.73 3.456-51.63 3.523-52.425.066-.795 1.13-4.507 1.13-4.507V.709H.71v1.944S1.774 6.364 1.84 7.16c.065.795 3.322 51.695 3.522 52.424.199.73.598 1.657.598 1.657s5.649.199 15.02.199"
  }), /*#__PURE__*/React.createElement("path", {
    id: "7s2cvm9gqe",
    d: "M3.612 22.458L23.24 22.458 22.356 36.541 4.498 36.541z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "jzuix9i66f",
    d: "M-2.25 70.198L24.425 70.198 24.425 0 -2.25 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "k3dd6l99ti",
    d: "M0.43 -0.33H126.43V143.67H0.43z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "23lyp9u8vk",
    d: "M0.188 -0.466H126.188V144.534H0.188z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "c9ddsty07a",
    width: "107.2%",
    height: "106.3%",
    x: "-3.6%",
    y: "-3.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "pgrnoczfsh",
    width: "107.1%",
    height: "106.2%",
    x: "-3.6%",
    y: "-3.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "ei60c704xj",
    width: "107.1%",
    height: "106.2%",
    x: "-3.6%",
    y: "-3.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-534 -227) translate(537 230) rotate(9 61.278 1546.637)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#c9ddsty07a)",
    xlinkHref: "#9ag2zbigbb"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#9ag2zbigbb"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FDF1EB",
    d: "M10.992 11.628H111.992V102.628H10.992z",
    transform: "translate(-534 -227) translate(537 230) rotate(9 61.278 1546.637)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-534 -227) translate(537 230) rotate(9 61.278 1546.637) translate(49.42 22.358)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "8bv8xn5fdd",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#g2zuulmw4c"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    stroke: "#231F20",
    strokeWidth: 1.38,
    xlinkHref: "#g2zuulmw4c"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#8bv8xn5fdd)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#7s2cvm9gqe"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFC4C7",
    xlinkHref: "#7s2cvm9gqe"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.38,
    d: "M1.925 6.161L24.661 6.249",
    mask: "url(#8bv8xn5fdd)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "7mx2d8ylfg",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#jzuix9i66f"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#231F20",
    strokeWidth: 1.38,
    d: "M5.961 69.489L20.586 69.489 20.586 61.175 5.961 61.175zM2.99 22.458L23.862 22.458M3.612 36.541L22.441 36.541",
    mask: "url(#7mx2d8ylfg)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-534 -227) translate(537 230) rotate(-14 125.498 14.93)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#pgrnoczfsh)",
    xlinkHref: "#k3dd6l99ti"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#k3dd6l99ti"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FDF1EB",
    d: "M10.965 10.876H112.965V102.876H10.965z",
    transform: "translate(-534 -227) translate(537 230) rotate(-14 125.498 14.93)"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#231F20",
    strokeWidth: 1.38
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFC4C7",
    d: "M17.391 10.883L20.607 11.188 20.607 28.647 2.978 28.647 2.978 11.188 4.844 10.883",
    transform: "translate(-534 -227) translate(537 230) rotate(-14 125.498 14.93) translate(49.965 18.876)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M22.513 32.049v-3.507H1.073v3.507L0 32.201v38.121c0 5.66 23.585 5.017 23.585 0v-38.12l-1.072-.153z",
    transform: "translate(-534 -227) translate(537 230) rotate(-14 125.498 14.93) translate(49.965 18.876) translate(0 .106)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.032 32.049L22.552 32.049",
    transform: "translate(-534 -227) translate(537 230) rotate(-14 125.498 14.93) translate(49.965 18.876) translate(0 .106)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF1EA",
    d: "M4.844 3.382L13.659.638h4.764l.318 1.677s-1.033.458-1.27 1.6c-.24 1.145-.08 6.863-.08 6.863s-5.45 2.135-12.547 0V3.382z",
    transform: "translate(-534 -227) translate(537 230) rotate(-14 125.498 14.93) translate(49.965 18.876) translate(0 .106)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-534 -227) translate(537 230) rotate(9 -168.108 907.267)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#ei60c704xj)",
    xlinkHref: "#23lyp9u8vk"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#23lyp9u8vk"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FDF1EB",
    d: "M12.883 11.243H114.883V103.243H12.883z",
    transform: "translate(-534 -227) translate(537 230) rotate(9 -168.108 907.267)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#373535",
    strokeWidth: 1.38,
    d: "M58.837 63.904H4.31c0-1.559-2.605-11.602-3.995-17.662C-.9 40.937 1.741 32.606 2.42 30.866c.107-.271.202-.548.275-.831C5.2 20.376 5.872 2.952 5.872 2.952S5.975 2.944 11.706 0c0 0 18.234 21.472 39.767 0l5.73 2.944s.674 17.425 3.18 27.083c.072.283.167.56.273.833.679 1.738 3.32 10.07 2.105 15.374-1.39 6.06-3.994 16.104-3.994 17.663H4.238",
    transform: "translate(-534 -227) translate(537 230) rotate(9 -168.108 907.267) translate(30.974 25.394)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#373535",
    strokeWidth: 1.38,
    d: "M3.563 59.242L59.511 59.242M10.742 6.845s11.354 3.083 11.354 24.241c0 1.583-.98 2.963-2.501 4.531",
    transform: "translate(-534 -227) translate(537 230) rotate(9 -168.108 907.267) translate(30.974 25.394)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF1EA",
    stroke: "#373535",
    strokeWidth: 1.38,
    d: "M10.742 6.845s11.354 3.083 11.354 24.241c0 1.583-.98 2.963-2.501 4.531-4.923-3.921-7.75-8.717-8.481-14.386-.73-5.67-.855-10.465-.372-14.386zM52.116 6.845S40.762 9.928 40.762 31.086c0 1.583.979 2.963 2.5 4.531 4.924-3.921 7.75-8.717 8.482-14.386.73-5.67.854-10.465.372-14.386z",
    transform: "translate(-534 -227) translate(537 230) rotate(9 -168.108 907.267) translate(30.974 25.394)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#373535",
    strokeWidth: 1.38,
    d: "M52.302 6.845S40.95 9.928 40.95 31.086c0 1.583.979 2.963 2.5 4.531",
    transform: "translate(-534 -227) translate(537 230) rotate(9 -168.108 907.267) translate(30.974 25.394)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#373535",
    strokeWidth: 1.38,
    d: "M11.706 0S3.15 38.904 31.537 38.904 51.473 0 51.473 0",
    transform: "translate(-534 -227) translate(537 230) rotate(9 -168.108 907.267) translate(30.974 25.394)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC1C6",
    d: "M4.529 59.84L58.878 59.84 58.26 63.227 5.362 63.227z",
    transform: "translate(-534 -227) translate(537 230) rotate(9 -168.108 907.267) translate(30.974 25.394)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurveyImageDesktop);
export default __webpack_public_path__ + "static/media/survey-image-desktop.9a951fbb69bcecbd0c587537d6dc30a0.svg";
export { ForwardRef as ReactComponent };